module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("1")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("EVERYDAY ZAKKA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("dd simple pleasures to your life by creating zakka items that can be \t\t used every day. Create Fabric Buckets with Hangtags to organize your living space and Eraser Stamped Lavender Sachets for your clothes closet. Accessorize your fashions with Crochet-Edged One-Yard Scarf and Cotton Flower Bag Charm. Many of these zakka items can be made with small pieces of fabrics and supplies—make them for your friends and family as thoughtful gifts and make them for yourself as well.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0007-02.jpg"
    }
  })])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec1"
    }
  }, [_vm._v("ERASER STAMPED LAVENDER SACHET")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" "), _c('em', [_vm._v("4 1/2\" (11.4 cm) square, not including the hanging loop")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A gently scented sachet filled with dried lavender is one of my favorite relaxing items. I embellished this sachet by stamping my hand-carved eraser stamps onto lightweight linen and framing it inside a coordinating fabric. Instead of carving your own stamp, use your favorite stamp from the local craft store. If you have difficulty stamping on linen, try using unbleached muslin instead. When stuffing dried lavender, be careful to avoid packing the lavender too firmly inside the sachet; keep it slightly loose so it will release the aroma when you squeeze it.")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adding a touch of European-inspired folk motifs and alphabet monograms is widely popular in the Japanese zakka design.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" scrap of lightweight linen, at least 3 1/2\" (8.9 cm) square, for the center")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" one fat eighth or 22\" × 9\" (55.9 cm × 22.9 cm) piece of cotton print, for the front frame and back")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" rubber or eraser-carved stamp that fits inside the 3\" (7.6 cm) square. Follow instructions (opposite) to carve your own eraser stamp.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" fabric ink pad")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 7\" (17.8 cm) lace ribbon, for the hanging loop")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 10\" (25.4 cm) grosgrain ribbon, 3/8\" (1 cm) wide, for the bow")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" dried lavender buds, approximately 2/3 cup or 20 to 30 g")])]), _c('p', {
    staticClass: "itembull"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" funnel (or make a paper funnel as described on ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#refch01"
    }
  }, [_vm._v("page 11")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" liquid seam sealer or craft glue to seal cut ends of ribbons")]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_c('strong', [_vm._v("Optional–If you carve your own eraser stamp:")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" eraser (Japanese eraser blocks made for eraser carving work well, but regular soft erasers are fine)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 2B pencil")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" tracing paper")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" sharp craft knife")]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut 3\" (7.6 cm) square from lightweight linen.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 1 1/2\" × 3\" (3.8 × 7.6 cm) strips from cotton print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 1 1/2\" × 5\" (3.8 × 12.7 cm) strips from cotton print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 5\" (12.7 cm) square from cotton print.")]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("Take extra care when using the craft knife. Always point the knife away from you when carving erasers.")])]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Optional: How to Carve Your Own Eraser Stamp")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Draw your original stamp design or trace a stamp pattern from ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 123")]), _vm._v(" onto a piece of tracing paper using a 2B pencil. Color the inside of the traced pattern with 2B pencil.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Using a craft knife, cut the eraser to fit the approximate size of the pattern. Place the traced pattern facedown on the eraser surface. Scratch the tracing paper well with your fingernail to transfer the design onto the eraser.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Using a craft knife, begin carving the eraser along the traced pattern. When carving, tilt the knife slightly toward the "), _c('em', [_vm._v("outside")]), _vm._v(" of the design. Carve along the entire outer line of the traced pattern. Cut off the unwanted corners and edges of the eraser.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Insert the knife at an angle in the opposite direction of the first cut to make a V-shaped cut on the eraser surface.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0009-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("5.")]), _vm._v(" Insert the knife into the side of the eraser to cut off the unwanted edge around the carved design. The carved design should stand out from the eraser surface for stamping."), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("6.")]), _vm._v(" Here are right and wrong examples of the carved eraser.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0010-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Stamp on Linen")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Ink the stamp and stamp it onto the 3\" (7.6 cm) linen square, centered. I used various colors of ink for stamping, but you can use a single color. After stamping, allow the ink to dry and heat set with a hot iron.")]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("To put ink on your stamp, tap the fabric ink pad several times onto the stamp surface, instead of pressing the stamp onto the ink pad. This is especially helpful if your ink pad comes in a small size. Also, wipe off the unwanted ink on the edge of the stamp using cotton swabs.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Front Panel")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Pin and sew 1 1/2\" × 3\" (3.8 × 7.6 cm) strips of cotton print to the top and bottom of the 3\" (7.6 cm) linen square. Press seams away from the linen square.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0010-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Pin and sew 1 1/2\" × 5\" (3.8 × 12.7 cm) strips of cotton print to the right and left sides of the opposite edges to form a square. Press seams away from the center.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0010-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Fold a 7\" (17.8 cm) piece of lace ribbon in half widthwise to form a loop.")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Aligning the raw edges, center the lace ribbon ends on the top edge of the right side of assembled front panel, with the loop end pointing toward the bottom of the front panel. Pin and sew in place, going back and forth to reinforce the stitches and using an 1/8\" (3 mm) seam allowance.")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Finish the Sachet")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides facing together, pin the assembled front panel and the square back together. Sew around all four sides, leaving a 2\" (5.1 cm) opening on one side. Be careful not to catch the trim’s loop end when you sew. Press to open seams. Trim the four corners.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0011-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Turn the sachet right side out through the opening and use a chopstick to push out the corners. Press again.")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "refch01"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Using a funnel, fill the sachet with dried lavender. Do not overfill. If you don’t have a funnel, roll a piece of paper in a cone, and tape it together.")])]), _c('a', {
    attrs: {
      "id": "refch01"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Hand-stitch the opening closed with a matching thread.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("5.")]), _vm._v(" Tie a bow using 10\" (25.4 cm) grosgrain ribbon at the bottom edge of the lace hanging. Gently pull the tails of the ribbon and cut off any excess. Dab a small amount of glue to both ribbon tails to seal the cut ends. Let dry.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("6.")]), _vm._v(" Using matching thread, stitch through the knot to secure the ribbon in place. Be very careful when passing a needle through the knot, as you are stitching through several layers.")]), _vm._v(" "), _c('p', {
    staticClass: "subheadV"
  }, [_c('strong', [_vm._v("For Variation")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0011-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This sachet is made from an upcycled pillow case and embellished with a store-bought vintage style stamp. TPC Studio’s Vintage Keys Rubber Cling Stamp is used.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "refch01"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "refch01"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec2"
    }
  }, [_vm._v("CROCHET-EDGED ONE-YARD SCARF")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" "), _c('em', [_vm._v("9 1/2\" × 72\" (24.1 × 182.8 cm)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It takes exactly one yard (0.92 m) of fabric to make this scarf. The edgings are crocheted separately using 100 percent cotton yarn and stitched onto the ends of the scarf with a sewing machine. Only the basic crochet stitches of chains, single crochets, and double crochets are used to make the edging strips. I used the same fabric for both the front and back sides of this scarf, but you can make it reversible by using a different fabric, or combine several scraps from your favorite fabrics. For optional embellishment, stitch a small scrap piece of lettered fabric to the bottom corner of the scarf, creating an original fabric label.")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This scarf incorporates both sewing and crocheting techniques into one project, a unique approach in the creation of Japanese zakka design.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 1 yd (0.92 m) cotton, lightweight linen, or cotton/linen blend. Yardage is based on 42\" (106.7 cm) wide fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap of fabric to cut out your selected word, set of alphabets or numbers, or any small motif to add fabric label embellishment to the scarf, optional")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 30 yds (27.5 m) four-ply 100% cotton yarn, in ecru, or any color to match your fabric. Sample uses Lily Sugar ’n Cream. (Yarn weight: 4 Medium)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" size 7/G (4.5 mm) crochet hook")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" steam iron")])]), _c('p', {
    staticClass: "materials"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut four 10\" × 36\" (25.4 × 91.4 cm) strips from 1 yd (0.92 m) fabric following the lengthwise fabric grain. See diagram as a guide.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("For easier pressing, cut out a rectangle template from firm cardboard, such as a postcard or cereal box, into your desired finished label size. Use the template to fold all four edges of the label piece inward with a hot iron.")])]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Join the Scarf Pieces")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, pin and sew the short edges of two fabric strips to make one long strip. Press open the seams. Repeat with the remaining two fabric strips to create another long strip. Now you have two long scarf strips.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0013-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Optional: Add your original fabric label")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Cut out a word, a set of letters or numbers, or any small motif of your choice from print fabric scrap to create original fabric label. When you cut out the motif, leave at least a 1/2\" (1.3 cm) seam allowance around the word or motif.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Fold and press the four edges of the scrap piece inward, to create a fabric label.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Position the label at the bottom right corner of the right side of the scarf strip. Pin the label 1 1/2\" (3.8 cm) inside from both corner edges. Pin and sew the label to the scarf using matching thread.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "himage90",
    attrs: {
      "alt": "Image",
      "src": "images/f0013-03.jpg"
    }
  })])]), _c('p', {
    staticClass: "materialsub"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Crochet the Edging")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Create two strips of crochet edging following the instructions and stitching diagram below. For a nice finish, steam the finished crochet edging using a steam iron. Pin the edging into desired shape on a flat ironing board. Hold steam iron several inches (cm) above the crocheted piece to steam the edging into shape.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Gauge:")])]), _vm._v(" "), _c('em', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Size of one crocheted edging is approximately 9 1/2\" × 1/2\" (24.1 × 3.8 cm)")])])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('strong', [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Ch 45.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Row 1: Dc in 4th ch from hook and in each ch across, turn. (43 dc)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Row 2: Ch 4 (counts as dc, ch 1), skip first 2 dc, *dc in next dc, ch 1, skip next dc; rep from * across, dc in top of turning ch, turn. (22 ch-1 spaces)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Row 3: Ch 1, sc in first dc, *ch 3, skip next ch-1 space, sc in next dc; rep from * across, ending with last sc in 3rd ch of turning ch. Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Finish the Scarf")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, combine the scarf strips, matching the center seams. Pin and sew around all sides, leaving at least a 4\" (10.2 cm) opening along one long edge. Press to open the seams. Clip the four corners. Turn the scarf right side out through the opening and use a chopstick to push out the corners. Press again.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Topstitch closely around the scarf, carefully catching the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Place crochet edging on the short edge of the front side of the scarf, which is the side the label (optional) is sewn onto. Overlap approximately 1/2\" (1.3 cm) of the scarf’s short edge and the first row of crochet edging (the entire row of double crochet). Pin and machine-stitch the crochet edging closely to the top edge using matching thread, as shown in the diagram.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Turn the scarf over to the reverse side. Sew the crochet edging and the scarf together from the reverse side using matching thread, but this time sew over the previously topstitched line on the scarf, to secure the crochet edging. You have now topstitched two lines over the crochet edging, one from the front side and another from the reverse side. Repeat for the opposite scarf end to attach the edging.")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subheadV"
  }, [_c('strong', [_vm._v("For Variation")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Beautiful and lightweight linen/cotton blend fabric in leaf print is used to make this scarf. For the label, I hand stamped and hand embroidered the outline of the clover motif onto a scrap of linen, and layered it on top of gingham check. Both labels’ edges are folded inward and sewn close to the edges.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec3"
    }
  }, [_vm._v("PATCHWORK LANYARD")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" "), _c('em', [_vm._v("Approximately 36\" (91.4 cm) long, or drops 18\" (45.7 cm) from the back of the neck to split ring")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This lanyard, or neck strap, will make a thoughtful gift for your child’s teacher, coach, medical professional, office worker, or any busy mom! It is also a great way to turn your fabric scraps into an everyday usable zakka item. Feel free to skip the rivets and leather strip attachment if you choose, though these details will surely add that zakka taste to your lanyard. The tools required to set your own rivets include 3/8\" (1 cm) diameter rivet cap and bottom, small piece of soft leather, rotary leather punch, and a nylon jaw flat-nose pliers. As long as you have all tools in your hands, setting rivets is quite simple.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" scraps of cotton print to create 2\" × 36\" (5.1 × 91.4 cm) strip")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" strip of fusible interfacing, 1\" × 35 1/2\" (2.5 × 90.2 cm). Interfacing is cut slightly shorter than the pieced strip.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 1\" (2.5 cm) split ring")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" swivel hook")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 3/8\" (1 cm) rivets, cap and bottom. I used a rivet bottom that is approximately 1/4\" (6 mm) tall.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small strip of soft leather remnant, 1/2\" × 2\" (1.3 × 5.1 cm)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" rotary leather punch")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" nylon jaw flat-nose pliers. This is a tool used for craft and jewelry making that comes with soft and protective nylon-covered jaws.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" zipper foot for your sewing machine (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" pins or sewing clips, such as Clover Wonder Clips")]), _vm._v(" "), _c('p', {
    staticClass: "subheadV"
  }, [_c('strong', [_vm._v("For Variation")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This patchwork lanyard is finished without the rivet and soft leather strip.")]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("I did not use normal rivet-setting tools, including rivet setter, anvil, and mallet, to set the rivets for this project, as I find nylon jaw flat-nose pliers more convenient. However, you may use rivet-setting tools if you choose, following the manufacturer’s instructions.")])])]), _c('p', {
    staticClass: "instru"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Sew the Pieced Strap")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Cut your fabric scraps into 2\" (5.1 cm) widths. Combine the pieces to create a 2\" × 36\" (5.1 × 91.4 cm) strip. Open all seams and press.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Fold the pieced 2\" × 36\" (5.1 × 91.4 cm) strip in half lengthwise, wrong sides together, and press. Unfold. Place a 1\" × 35 1/2\" (2.5 × 90.2 cm) fusible interfacing strip over half of the wrong side of the pieced strip. Interfacing is cut slightly shorter than the pieced strip, leaving both short ends free of interfacing. Refold in half lengthwise, and press to fuse the interfacing to the wrong side of the pieced strip. Fold the long edges to meet in the center, and press again.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("Instead of holding the open side of the loop together with regular pins, try using sewing clips such as Clover Wonder Clips. They are a convenient and helpful tool when holding thick fabrics together.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0018-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Slip one end of the pieced strip through the split ring. With right sides together, connect the short ends of the pieced strip, being careful not to twist the strip. Sew the raw ends together to form a loop. Pin and topstitch along both edges of the loop, stitching 1/8\" (3 mm) from the edges. (If you forget to slip the strip through the split ring before sewing into a loop, it’s okay. Simply open the split ring and attach it onto the loop.)")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Move the split ring around the loop to the desired location. This step is important because the fabric close to the ring (and the rivets) will be most visible when the lanyard is worn. Once the rivet position is set, topstitch across two layers of the lanyard, as close to the split ring as possible. It may be helpful to change your machine foot to zipper foot. If you do not plan to attach rivets, your lanyard is now finished. Simply attach the swivel hook to the split ring.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "himage90",
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Finish the Lanyard")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Prepare the soft leather strip. Mark two rivet points on the right side of a 1/2\" × 2\" (1.3 × 5.1 cm) soft leather strip with a pencil, 1/4\" (6 mm) from each short edge, centered. Wrap the connected end of the lanyard with the soft leather strip, right side facing out. Select the hole size of the rotary leather punch that best fits the diameter of the rivet shaft. (I used the smallest hole of the rotary leather punch.) At the marked rivet point, punch through the two layers of soft leather and two layers of lanyard, at once.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Connect all punched holes and insert the rivet cap and rivet bottom from each side of the hole. Using nylon jaw flat-nose pliers, firmly hold rivets from both sides to set in place. Attach a swivel hook to the split ring.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec4"
    }
  }, [_vm._v("RICE THERAPY EYE PILLOW")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" "), _c('em', [_vm._v("8 1/2\" × 5\" (21.6 × 12.7 cm)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This eye pillow is filled with uncooked Japanese dry rice. Heat it in the microwave for hot therapy, or place it in a zipper plastic bag and then into a freezer for cold therapy. Use it at bedtime and the embroidered sleepy sheep on the front panel may help put you to sleep. You may replace dry rice with flaxseeds or dry adzuki beans and add lavender buds or essential oils for aromatherapy. The rice filling is kept securely inside the inner muslin bag, and the outer case has an envelope back closure that is removable and washable. Do not overheat the eye pillow in the microwave, and be careful to avoid letting the rice filling become wet.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 1 fat eighth or 22\" × 9\" (55.9 × 22.9 cm) checkered print, for the front frame and back")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 1 fat eighth or 22\" × 9\" (55.9 × 22.9 cm) floral print, for the front frame and back")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap linen, at least 8\" × 4\" (20.3 × 10.2 cm), to piece the outer bag")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" scrap unbleached muslin, at least 11\" (27.9 cm) square, for the inner pillow")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" dry rice, approximately 3/4 cup (160 g)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" dried lavender buds, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" funnel, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" embroidery floss or pearl cotton thread")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" pattern transfer paper, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" water-soluble pen, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" black permanent marker, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" masking tape, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" pinking shears, optional")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "imgfloat"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg",
      "width": "100px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rice is the primary crop in Japan. Japanese rice is short grain and when cooked has a sticky texture. Cooked steamy rice with a hot miso soup is a comfort food for many Japanese people.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _c('p', {
    staticClass: "materials"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 7\" × 3 1/2\" (17.8 × 8.9 cm) rectangle from the linen.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 7\" × 1 1/2\" (17.8 × 3.8 cm) strips from the checkered print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 6\" × 5 1/2\" (15.2 × 14 cm) rectangle from the checkered print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 5 1/2\" × 1 1/2\" (14 × 3.8 cm) strips from the floral print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 6\" × 5 1/2\" (15.2 × 14 cm) rectangle from the floral print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 8 3/4\" × 5 1/4\" (22.2 × 13.3 cm) rectangles from the unbleached muslin.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The envelope back closure makes it easy to remove and wash the eye pillow cover. The rice filling is secured inside the inner muslin bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Front Panel")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Pin and sew 7\" × 1 1/2\" (17.8 × 3.8 cm) strips of checkered print to the top and bottom of the linen panel. Press seams away from the linen panel.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0022-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Pin and sew 5 1/2\" × 1 1/2\" (14 × 3.8 cm) strips of floral print to the right and left sides of the pieced panel. Press seams away from the linen panel.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0022-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Trim the pieced panel to 9\" × 5 1/2\" (22.9 × 14 cm).")])]), _c('p', {
    staticClass: "materialsub"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Transfer and Embroider the Sheep Pattern")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Trace the embroidery design on ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 126")]), _vm._v(" to the bottom right corner of the front linen panel, approximately 1/2\" (1.3 cm) from the corner edges. Use the pattern transfer paper, following the manufacturer’s instructions, or refer to step 1 of Transfer and Embroider Sashiko Design on Sashiko-Style Coasters ("), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 104")]), _vm._v(") for the Sunny Window method. With this method, design is transferred using a marker, masking tape, and water-soluble pen with the sunlight from the window.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Embroider the pattern onto the linen panel with embroidery floss or pearl cotton thread, using backstitches.")]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Finish the Outer Case")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Create a double-folded hem on one short edge of each back piece. Fold and press one short edge of the 6\" × 5 1/2\" (15.2 × 14 cm) checkered print piece, forming a 1/2\" (1.3 cm) seam. Then press under another 1/4\" (6 mm) inward to create a double-folded hem. Pin and topstitch in place from the wrong side. Repeat for the 6\" × 5 1/2\" (15.2 × 14 cm) floral print piece.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" With right sides together, place the back pieces over the front, overlapping them approximately 1 1/2\" (3.8 cm) at the center. Pin and sew around all four edges. Use pinking shears to cut off excess seam around the edges, to prevent fraying (optional). Turn right side out and push out corners using a chopstick. Press.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0023-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Inner Pillow")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Align and pin two 8 3/4\" × 5 1/4\" (22.2 × 13.3 cm) muslin rectangles together, and sew around all four edges leaving at least a 2\" (5.1 cm) opening on one side. Clip all corners. Turn the pillow right side out through the opening and push out the corners using a chopstick.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Using a funnel, insert dry rice through the opening. If you don’t have a funnel, create your own by rolling a piece of paper into a cylinder shape and taping it together. Add a few spoons of lavender buds (optional), according to your preference. Machine-stitch close to the edge to close the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Insert the inner pillow inside the outer case.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev1sec5"
    }
  }, [_vm._v("MATRYOSHKA DOLL KEY COVER")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" 3\" × 3 1/2\" (7.6 × 8.9 cm), not including the cords")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I designed this key cover from the love of matryoshka, or Russian nesting dolls. This key cover is fully lined with lightweight batting and linen, and the cushioned cover prevents your keys from scratching other items in your purse, such as your cell phone. A split key ring placed inside the key cover holds the keys, and the keys can easily be pulled down to use. The doll’s face is machine appliquéd onto the exterior front cover and her eyes and mouth are hand-stitched with care. Add jacquard ribbons, lace trims, cotton tapes, or ricrac trims to embellish the dress of the matryoshka.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap of red and white gingham check print, 8\" × 5\" (20.3 × 12.7 cm), for the exterior")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap of linen, 12\" × 5\" (30.5 × 12.7 cm) for the lining and face")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap or 2\" (5.1 cm) square of cotton print for hair")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" one or two 4\" (10.2 cm) length trims of various widths to embellish the front panel")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 1\" (2.5 cm) diameter split key ring")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 14\" (35.6 cm) length of 1 mm or 2 mm waxed cotton cord, color of choice")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" one round wood bead, 12 mm in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" batting, 8\" × 5\" (20.3 × 12.7 cm)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" lightweight paper-backed fusible web, such as HeatnBond Lite, at least 5\" (12.7 cm) square to fuse face and hair")])]), _c('p', {
    staticClass: "itembull"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("• machine sewing threads to match the color of face, hair, and the ribbon trims")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" embroidery floss or pearl cotton thread to embroider eyes and mouth")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" pencil")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" water-soluble pen")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" basting spray, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" cotton swab to wipe off marks from water-soluble pen, optional")]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])])]), _c('p', {
    staticClass: "itembull"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Trace the patterns on ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 122")]), _vm._v(" to make templates for the key cover, face and hair.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two key cover panels from the red and white gingham check print using the key cover template.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two key cover panels from the linen using the key cover template.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 3\" (7.6 cm) square from the linen.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 2\" (5.1 cm) square from the cotton print.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two panels from the batting using the key cover template.")]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Embroider the Face")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Following the fusible web manufacturer’s instructions, iron the paper-backed fusible web onto the "), _c('em', [_vm._v("wrong")]), _vm._v(" side of the 3\" (7.6 cm) linen square.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Trace the outline of the face template onto the paper side of the fused linen square with a pencil. Do not trace the eyes and mouth. Cut out the face and peel off the paper backing.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Arrange the face onto the right side of the exterior panel, at least 1/2\" (1.3 cm) from the top edge, centered. Press and fuse in place.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Based on the diagram, draw eyes and a mouth on the bottom half of the linen face using the water-soluble pen. Embroider the eyes and mouth using embroidery floss or pearl cotton thread. Use satin stitches for the eyes, and use backstitches for the eyelashes and the mouth. (See step 2 on "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 80")]), _vm._v(" for instructions on satin stitching. See step 2 on "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 47")]), _vm._v(" for instructions on backstitching.) Wet a cotton swab (optional) with few drops of water and dab over the marked lines of the water-soluble pen. Let dry.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Assemble the Exterior Panels")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Spray-baste or pin the batting to the wrong sides of both the front and back exterior panels.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Using the matching colored sewing thread, topstitch twice around the doll’s face, approximately 1/8\" (3 mm) from the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Just as you did with the doll’s face, iron the paper-backed fusible web onto the "), _c('em', [_vm._v("wrong")]), _vm._v(" side of the 2\" (5.1 cm) print square to create hair. Trace the hair template onto the paper side of the fused print using a pencil. Cut out the hair and peel off the paper backing.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Change the sewing machine thread to match the color of the hair. Place the hair on top of the face, centered, aligning the top edges. Press and fuse in place using a tip of the iron. Topstitch twice around the hair close to the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("5.")]), _vm._v(" Arrange the trims on the right side of the front panel, right below the face. Pin the trims in place, leaving at least 1/2\" (1.3 cm) from the bottom edge. Using matching colored sewing threads, sew along the long edges of the trims.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Key Cover")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, pin the exterior panel and the lining at the top edge. Sew along the top edge. Open the seams and press. Repeat with the remaining exterior and lining panels.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Place the front and back right sides together. Pin and sew around the pieces, leaving 1/2\" (1.3 cm) cord openings at top and bottom center for both sides and 1 1/2\" (3.8 cm) opening on the lining for turning. Open seams and press. Cut notches around the curves, taking care not to cut the seam.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-03.jpg"
    }
  })])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Turn the key cover right side out through the opening in the lining. Hand-stitch or machine-stitch the opening of the lining closed.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Insert the lining inside the exterior cover. Push out corners and edges using a chopstick. Fold under the outer fabric and lining at the top opening and hand-stitch the folds together.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0027-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("To match the exterior and the lining together at the top opening, first push the raw edge of the lining outside of the key cover through the top opening using a chopstick. Be careful not to poke through the fabric. Then push the seams back inside the lining, carefully hiding the seams of both fabrics. Match the opening edge, and hand-stitch the fabrics together.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Pass Cords and Finish the Key Cover")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Fold the cord in half to make a loop and match both raw ends together. Pass the loop end of the cord through the top opening into the lining. Fasten a split key ring to the loop end.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Pull both ends of the cord and thread through the wood bead. Tie the cord ends together securely. Cut off the excess cords.")]), _vm._v(" "), _c('div', {
    staticClass: "limit70"
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "himage",
    attrs: {
      "alt": "Image",
      "src": "images/f0027-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("If the hole of your wood bead is too small to pass two cords, use a tapered awl to carefully poke through the bead hole from both ends to enlarge the hole openings before threading the cords. Match both raw ends of the cord and thread through the wood bead.")])])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec6"
    }
  }, [_vm._v("FABRIC BUCKET WITH HANGTAG")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Large Size:")])]), _vm._v(" "), _c('em', [_vm._v("11 1/2\" diameter × 12 1/4\" height (29.2 cm diameter × 31.1 cm height)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Medium Size:")])]), _vm._v(" "), _c('em', [_vm._v("9 1/2\" diameter × 11 1/4\" height (24.1 cm diameter × 28.6 cm height)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make these oversized fabric buckets in two different sizes to match any room of your house for organization and display. Or, stuff the bucket with baby items, children’s toys, or craft supplies to make a practical gift presentation. Select medium-to heavyweight cotton or home decor–weight fabric for the bucket’s exterior. For the lining, use double-sided pre-quilted fabric for durability and to hold its shape. Look around your kitchen to find a dinner plate, cake pan, cooking pot, mixing bowl, or any round items that are 10\" (25.4 cm) and 12\" (30.5 cm) diameter. They will be used as templates to trace circles for the bucket bottoms. Create matching hangtags using remnants for easy labeling of contents or to use as gift tags for a personalized touch.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 3/4 yd (0.69 m) medium-to heavyweight cotton or home décor–weight fabric")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 3/4 yd (0.69 m) double-sided pre-quilted fabric")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Note about fabrics: The fabric required is the same for the large and medium buckets and is based on 42\" (106.7 cm) wide fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" fusible interfacing, 20\" × 8\" (50.8 × 20.3 cm), to make handles")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 12\" (30.5 cm) dinner plate, cake pan, cooking pot, mixing bowl, or any round item to use as template for the "), _c('em', [_vm._v("large")]), _vm._v(" bucket bottom")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 10\" (25.4 cm) dinner plate, cake pan, cooking pot, mixing bowl or any round item to use as template for the "), _c('em', [_vm._v("medium")]), _vm._v(" bucket bottom")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" water-soluble pen, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" pins or sewing clips, such as Clover Wonder Clips")]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("For Large Bucket:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 37 3/4\" × 13\" (95.9 × 33 cm) rectangle from medium-to heavyweight cotton or home décor fabric, for exterior panel.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 12\" diameter (30.5 cm) circle from medium-to heavyweight cotton or home décor fabric using 12\" (30.5 cm) dinner plate, cooking pot, pans, or bowl as template.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 10\" × 4\" (25.4 × 10.2 cm) strips from medium-to heavyweight cotton or home décor fabric, for handles.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 37 3/4\" × 12 3/4\" (95.9 × 32.4 cm) rectangle from double-sided pre-quilted fabric, for lining.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 12\" (30.5 cm) diameter circle from double-sided pre-quilted fabric using 12\" (30.5 cm) dinner plate, cooking pot, pans, or bowl as template.")])]), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('strong', [_vm._v("For Medium Bucket:")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 31 1/2\" × 12\" (80 × 30.5 cm) rectangle from medium-to heavyweight cotton or home décor fabric, for exterior panel.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 10\" diameter (25.4 cm) circle from medium-to heavyweight cotton or home décor fabric using 10\" (25.4 cm) dinner plate, cooking pot, pan, or bowl as template.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 10\" × 4\" (25.4 × 10.2 cm) strips from medium-to heavyweight cotton or home décor fabric for handles.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 31 1/2\" × 11 3/4\" (80 × 29.9 cm) rectangle from double-sided pre-quilted fabric, for lining.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 10\" diameter (25.4 cm) circle from double-sided pre-quilted fabric using 10\" (25.4 cm) dinner plate, cooking pot, pan, or bowl as template.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('strong', [_vm._v("For Both Sizes:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 10\" × 4\" (25.4 × 10.2 cm) strips from interfacing.")]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("The length (or height) of the lining is cut 1/4\" (6 mm) shorter than the exterior so the lining will fit smoothly inside the bucket exterior.")])]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted. The steps are the same regardless of the bucket size.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Exterior")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, fold the exterior panel in half widthwise and sew the short edges together. Press to open side seam. You have sewn the exterior panel into a tube.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Fold the exterior circle into a quarter circle, creating four creases. You can do this by folding the circle in half and then folding it over again in half. Open the circle and mark all edges of the creases using a water-soluble pen (optional) or by cutting small notches with a scissor tip.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Create four even creases on the bottom edge of the exterior tube that you created in step 1. Using a water-soluble pen (optional) or by cutting small notches with a scissor tip, make four equal marks around the tube’s bottom edge. With right sides together, match the marks on the circle with the marks on the tube edge, aligning the raw edges. Pin the four quarter sections together. Continue to pin around the bottom edge of the circle by filling between these four pins.")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Sew around the entire circle. Go slowly and stop often, and rotate the fabric around the pivot as you go. After stitching, cut small notches around the entire outer edge of the circle, taking care not to cut the seam. Now you have sewn the exterior bucket with a round bottom.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0031-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Lining")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, fold the lining panel in half widthwise and sew the short edges together, just as you did with the exterior panel. However, this time leave a 4\" (10.2 cm) opening along the edge. You have sewn the lining panel into a tube.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Repeat steps 2 to 4 of Assemble the Exterior to sew the lining circle and the lining tube ends together. Cut notches around the outer edge of the circle, taking care not to cut the seam. Now you have sewn a bucket lining with a round bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Make and Attach Handles")])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Fuse a 10\" × 4\" (25.4 × 10.2 cm) strip of heavyweight interfacing to the entire wrong side of the 10\" × 4\" (25.4 × 10.2 cm) strip, following manufacturer’s instructions. Fold the long edges in half lengthwise, wrong sides together, and press. Then fold long edges to meet in the center and press. Pin and topstitch 1/8\" (3 mm) from both long edges. Repeat to make the remaining handle. You now have two handles that are each 10\" × 1\" (25.4 × 2.5 cm) long. For diagram of making the handles, see step 1 on ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 48")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Pin both ends of the handle to the top edge of the right side of the exterior bucket, aligning the raw edges. Make sure the handle is centered with 3\" (7.6 cm) between the handle ends. Machine-baste the handle ends approximately 1/8\" (3 mm) from the top edge. Repeat to attach the remaining handle across from the first handle.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0031-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Finish the Bucket"), _c('a', {
    attrs: {
      "id": "page_32"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" With right sides together, insert the exterior bucket inside the lining and match the side seams together. Align the raw edges at the top. The handles should be sandwiched between the exterior bucket and the lining. Pin and sew around the entire top edge. Using sewing clips instead of pins may be helpful to hold the exterior and the lining together at the bucket opening.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Turn the bucket and the lining right side out through the opening in the lining. Hand-or machine-stitch to close the opening. Insert the lining back into the exterior and press around the opening for a clean finish. Topstitch around the upper edge of the bucket approximately 1/8\" (3 mm) from the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0032-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("HOW TO MAKE A FABRIC HANG TAG")]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" remnant scraps from making fabric bucket’s exterior, at least 4\" × 11\" (10.2 × 27.9 cm)")])]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" scrap of batting, at least 5\" (12.7 cm) square")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" piece of clear vinyl, at least 5\" (12.7 cm) square. I used a heavyweight sheet protector from our office supply.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" cord, trim, ribbon, hemp, or any string to hang the tag, 11\" (27.9 cm) (I used size 4.0 mm/F crochet hook and Lily Sugar ’n Cream 100% four-ply cotton yarn in Ecru to create 11\" [27.9 cm] long crochet chain cord.)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" rotary cutter, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" basting spray, optional")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" sewing clips (such as Clover Wonder Clips) or other sewing clips or clothespins to hold vinyl and fabrics together")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" business card or hard paper cut into 3 1/2\" × 2\" (8.9 × 5.1 cm) rectangle, to place inside the hangtag for labeling")]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut two 3 1/2\" × 5\" (8.9 × 12.7 cm) rectangles from bucket exterior fabric remnants.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 3 1/2\" × 5\" (8.9 × 12.7 cm) rectangle from batting.")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Cut one 2 1/2\" × 4\" (6.4 × 10.2 cm) rectangle from clear vinyl.")])]), _c('p', {
    staticClass: "instru"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('strong', [_vm._v("INSTRUCTIONS")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Make the Fabric Hangtag")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Spray-baste or pin the batting to the wrong side of one 3 1/2\" × 5\" (8.9 cm × 12.7 cm) rectangle. This will be the front panel of the hangtag.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Fold the 11\" (27.9 cm) string in half. Aligning raw edges, center the string ends on one short edge of the right side of the front panel. Pin and sew in place 1/8\" (3 mm) from the edge, going back and forth to reinforce the stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0033-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" With right sides together, pin the front and back panels together. Sew around all four sides, leaving a 2\" (5.1 cm) opening on one long side. Backstitch over the string ends for reinforcement. Be careful not to catch the string’s loop end while you sew. Trim the corners and press the seams open.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4.")]), _vm._v(" Turn the hangtag right side out through the opening. Use a chopstick to push out the corners. Press again. Hand-stitch to close the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("5.")]), _vm._v(" Place the 2 1/2\" × 4\" (6.4 × 10.2 cm) clear vinyl rectangle on top of the front side of the hangtag, centered. Use sewing clips or clothespins to hold the vinyl in place; do not use regular pins, as they will punch holes in the vinyl. Stitch all three sides close to the edges, using approximately 1/8\" (3 mm) seam allowances and leaving the opening unsewn. Backstitch a few times at the beginning and end for reinforcement. Write or stamp words on the back side of the business card and place it inside the finished hangtag.")]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("If you have difficulty figuring out the topstitch line of clear vinyl, trace around the vinyl edges with a water-soluble pen. Then carefully topstitch the inner edges of vinyl. Wipe off the marked ink with damp cotton balls after stitching.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0033-02.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec7"
    }
  }, [_vm._v("COTTON FLOWER BAG CHARM")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Finished Size:")])]), _vm._v(" "), _c('em', [_vm._v("Approximately 3\" × 8\" (7.6 × 20.3 cm) long, not including the chains")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Dress up your bag with this sweet crocheted flower charm. The crocheted flower is worked into triple layers using cotton yarns, and a matching covered button is placed in the center of the flower. Pieces of trims and leather strips embellish the flower charm. Sew a Simple Linen Tote to create a coordinating bag set (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 68")]), _vm._v(") or accessorize the bag you have in hand. Metal chains are attached to the back side of the charm for hanging, but you can affix a brooch pin back to create a corsage or add a split ring to use as a key ring.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0034-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materials"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('strong', [_vm._v("Fabric:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap of cotton print, at least 2\" (5.1 cm) square, to make the covered button")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" small scrap of batting, at least 1\" (2.5 cm) square, to wrap the metal button shell, optional")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('strong', [_vm._v("Other Supplies:")])]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" 20 yd (18.5 m) four-ply 100% cotton yarn. Sample uses Lily Sugar ’n Cream in Ecru. (Yarn weight: 4 Medium)")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" size 7/G (4.5 mm) crochet hook")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" tapestry needle")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" two to three kinds of trim, such as lace, pompoms, and ribbon, for embellishment, each at least 14\" (35.6 cm) long")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" one leather strip, at least 14\" (35.6 cm) long")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" one size 36 or 7/8\" (2.2 cm) covered button and kit")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" strong thread")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" metal chain, 4\" (10.2 cm) long, antique gold, brass, or bronze")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" metal clasp, antique gold, brass, or bronze")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" jump ring, 10 mm or larger, antique gold, brass, or bronze color")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" two jewelry pliers")]), _vm._v(" "), _c('p', {
    staticClass: "itembull"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" fabric glue, optional")]), _vm._v(" "), _c('p', {
    staticClass: "instru"
  }, [_c('strong', [_vm._v("INSTRUCTIONS")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Seam allowances are 1/4\" (6 mm) unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Crochet the Layered Flower")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Crochet a layered flower following the instructions and stitching diagram below. Leave at least 12\" (30.5 cm) tail of yarn at the beginning of the first round; this will be used to attach the covered button in the center of the flower.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_c('span', {
    staticClass: "ash1"
  }, [_vm._v("Gauge:")])]), _vm._v(" "), _c('em', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Size of crocheted layered flower is approximately 3\" (7.6 cm) in diameter")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Start with adjustable ring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Row 1: Ch 6 (counts as dc, ch 3), (dc, ch 3) 5 times in ring, join with a sl st in 3rd ch of beginning ch. (6 ch-3 spaces)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rnd 2: Ch 1, (sc, hdc, 2 dc, hdc, sc) in each ch-3 space around, join with a sl st in first sc. (6 petals)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rnd 3: Ch 1, working behind petals in Rnd 2, BPsc around the post of first dc in Rnd 1, ch 5, *BPsc around the post of next dc in Rnd 1, ch 5; rep from * around, join with a sl st in first sc. (6 ch-5 spaces)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rnd 4: Ch 1, (sc, hdc, 3 dc, hdc, sc) in each ch-5 space around, join with a sl st in first sc. (6 petals)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rnd 5: Ch 1, working behind petals in Rnd 2, BPsc around the post of first dc in Rnd 1, ch 6, *BPsc around the post of next dc in Rnd 1, ch 6; rep from * around, join with a sl st in first sc. (6 ch-6 spaces)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rnd 6: Ch 1, (sc, hdc, 5 dc, hdc, sc) in each ch-6 space around, join with a sl st in first sc. (6 petals) Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0035-01.jpg"
    }
  })])]), _c('div', {
    staticClass: "tipa"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")])]), _c('p', {
    staticClass: "tip"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Sometimes the metal button shell can show through thin or light-colored fabric. To avoid this, cut a piece of batting slightly larger than the button size. Use fabric glue to affix the batting to the wrong side of the fabric circle, centered. Then cover the fabric button as usual. The batting adds softness to the covered button and obscures the metal button.")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Create and Attach Covered Button")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Following the manufacturer’s instructions, cover the fabric button with a coordinating cotton print scrap.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Thread the beginning yarn tail of the crocheted flower onto the tapestry needle and pass the needle through the back center to the front of the flower. Pass the yarn through the button shank and stitch to the center front of the flower several times. Wrap the shank with the yarn a few times and bring the needle to the back of the flower. Pull the yarn tightly, make a knot, and weave in the ends. Cut off the excess yarn tail.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0036-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "materialsub"
  }, [_vm._v("Assemble the Bag Charm")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1.")]), _vm._v(" Cut the trims into various lengths, between 13\" and 14\" (33 and 35.6 cm) long. Fold all trims, except for the leather strip, in half widthwise. Using double strands of thread, stitch the trims together approximately 1/4\" (6 mm) below the fold. Wrap the trims tightly together a few times and take several more stitches to attach the folded edges of the trim to the center back side of the flower. Be careful, as you are working with several layers of material. Pull the thread tight, make a knot, and cut off the excess thread.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "himage90",
    attrs: {
      "alt": "Image",
      "src": "images/f0036-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2.")]), _vm._v(" Fold the leather strip in half widthwise, as you did with the other trims. Using double strands of thread in matching color, wrap around the folded leather strip and attach to the center back side of the crochet flower, on top of the other trims. Repeat to wrap around the entire trims and stitch to the back side of the crochet flower, approximately  3/4\" (1.9 cm) below the first one.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3.")]), _vm._v(" Using two jewelry pliers, attach one 10 mm or larger sized jump ring to the upper center spoke of the crochet petal. Attach the 4\" (10.2 cm) metal brass chain to the jump ring. At the opposite end of the metal chain, attach the clasp.")]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('img', {
    staticClass: "wimage",
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipa"
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("Stitch the leather strip to the back side of the crochet flower after the other trims are attached. The leather strip is thicker and trickier to work with, so it is best to stitch it separately from other trims.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "limit70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "himage",
    attrs: {
      "alt": "Image",
      "src": "images/f0037-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wrap around and stitch the trims to the back side of the crochet flower twice to secure the embellishment in place.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 63
// module chunks = 0